const processBoxStyle = {
  stepText: {
    margin: 0,
  },
  textBlock: {
    marginTop: { xs: "0", md: "0.625rem" },
    marginBottom: { xs: "0", md: "0.625rem" },
  },
  done: {
    textDecoration: "line-through",
  },
  iconContainer: {
    width: "70px",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    alignContent: "center",
    alignItems: "center",
  },
  connectorLine: {
    flexGrow: 1,
    borderLeft: "1px solid",
    borderColor: "iconColor.main",
  },
  connectorLineInvisible: {
    flexGrow: 1,
  },
  progressIcons: {
    width: "2rem",
    height: "2rem",
    display: "block",
  },
};

export default processBoxStyle;
